var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembershipCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vg5b8und4a",
    d: "M0 0h20v19.167H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.66 8.775 1.369 1.85a.077.077 0 0 1 0 .082l-1.369 1.837h-.106l-1.369-1.837a.076.076 0 0 1 0-.082l1.369-1.85h.106z",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61 .833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3w0krsq9gb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vg5b8und4a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.562 10.738-1.369 1.85a1.5 1.5 0 0 1-1.197.598 1.5 1.5 0 0 1-1.196-.598l-1.37-1.85a1.538 1.538 0 0 1 0-1.812L8.8 7.058a1.501 1.501 0 0 1 1.196-.598c.47 0 .912.221 1.197.598l1.369 1.894a1.538 1.538 0 0 1 0 1.78v.006zm6.1-6.313-1.25 1.263a2.33 2.33 0 0 1-3.663-.391L10.624.366a.779.779 0 0 0-1.318 0L6.18 5.296a2.33 2.33 0 0 1-3.637.404l-1.25-1.262a.777.777 0 0 0-1.071.044.793.793 0 0 0-.223.537l.419 10.328H16.43v1.446H.48v.1c.026.612.284 1.189.72 1.612.437.424 1.019.66 1.624.662h14.337a2.337 2.337 0 0 0 1.623-.662c.436-.423.695-1 .72-1.611L20 5.019a.794.794 0 0 0-.21-.58.777.777 0 0 0-1.127-.014z",
    fill: "#AEB3B7",
    mask: "url(#3w0krsq9gb)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipCs);
export default __webpack_public_path__ + "static/media/membership-cs.e910cb60b044d198e0e2214916e869be.svg";
export { ForwardRef as ReactComponent };